<template>
    <div data-testid="specialities-filter">
        <h3>{{ $t('search.filters.keyword.title') }}</h3>
        <CollapsibleList data-testid-prefix="specialities-filter" :min-visible-items="6" :items="specialities">
            <template #default="{item: speciality, visible}">
                <VJoyCheckbox
                    v-show="visible"
                    :checked="isChecked(speciality.key)"
                    :data-testid="`specialities-filter-${speciality.key}`"
                    :label="`${speciality.label} (${speciality.count})`"
                    @update:checked="toggleFilter(speciality.key)"
                />
            </template>
        </CollapsibleList>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyCheckbox} from '@maltjoy/core-vue';
    import CollapsibleList from '~/components/common/CollapsibleList.vue';
    import {useFiltersStore} from '../stores/filters.store';

    const filtersStore = useFiltersStore();
    const {availableSearchFilters} = storeToRefs(filtersStore);

    const specialities = computed(() => availableSearchFilters.value?.specialities ?? []);

    function isChecked(speciality: string) {
        return filtersStore.isFilterChecked('specialities', speciality);
    }

    function toggleFilter(specialityFilter: string) {
        filtersStore.toggleFilter('specialities', specialityFilter);
    }
</script>
